module.exports = __webpack_public_path__ + "media/images/pic/anime/awards-8d04f9b5ba9cc2af0aae99bb5da501db.svg";